module.exports = __webpack_public_path__ + "static/media/Riyadh_Skyline.ea377159.jpg";